import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="row">
            <div className="ft-col-1">
              <div className="widget">
                <div className="widget-content">
                  <h4>EME Crypto</h4>
                  <p>
                    Explore the future of cryptocurrencies with EME. 
                    Our cutting-edge technology takes you towards new financial horizons, 
                    with transactions as fast as starlight.
                  </p>
                </div>
              </div>
            </div>

            <div className="ft-col-2">
              <div className="widget">
                <div className="widget-content">
                  <h4 className="widget-title">Contact Us</h4>
                  <p>info@themecrypto.it</p>
                </div>
              </div>
            </div>

            <div className="ft-col-3">
              <div className="widget">
                <div className="widget-content">
                  <h4 className="widget-title">Newsletter</h4>
                  <form className="mc4wp-form" onSubmit={(e) => e.preventDefault()}>
                    <div className="theme-mailchimp">
                      <div className="theme-mailchimp-fields">
                        <input 
                          type="email" 
                          name="email" 
                          placeholder="Enter your email" 
                          required 
                        />
                        <input type="submit" value="Subscribe" />
                      </div>
                      <p>Receive all the latest updates</p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-credits">
            <p className="footer-copyright">
              Copyright ©2025 Theme crypto
            </p>
          </div>

          <nav className="footer-menu-wrapper" aria-label="Footer">
            <ul className="footer-menu">
            <li><a href="/" aria-current="page">Home</a></li>
              <li><a href="https://www.themecrypto.it/chi-siamo/">About Us</a></li>
              <li><a href="https://www.themecrypto.it/contattaci/">Contact Us</a></li>
              <li><a href="https://www.themecrypto.it/blog/">Blog</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
